module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.expanded != true && _vm.$route.query.expanded !== 'true'),
      expression: "$route.query.expanded!=true && $route.query.expanded !== 'true'"
    }],
    staticClass: "timeline row",
    class: {
      'course-timeline': _vm.isCoursePage, 'mentor': _vm.localStorage.roles.includes('Mentor')
    },
    style: ({
      'background': _vm.courseBackground()
    })
  }, [_vm._v("\n    " + _vm._s(_vm.getCurrentWeek) + "\n\n    "), (!_vm.noTerm) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.$store.getters.currentTerm) ? _c('div', {
    staticClass: "current-week col-sm-3"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('You can drag this timeline to scroll it. Clicking past weeks will show you the content for that week (great for reviewing the past)'),
      expression: "'You can drag this timeline to scroll it. Clicking past weeks will show you the content for that week (great for reviewing the past)'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), (new Date(_vm.$store.getters.currentTerm.startDate) <= new Date()) ? _c('span', {
    staticClass: "week-number"
  }, [(_vm.isVideoPlayer) ? _c('span', [_vm._v("\n                Week " + _vm._s(_vm.timeTravelWeek + 1) + "                  \n            ")]) : _c('span', [_vm._v("\n                Week " + _vm._s(_vm.currentWeek + 1) + "\n            ")])]) : _c('span', {
    staticClass: "week-number"
  }, [_vm._v("Week 1")]), _vm._v(" "), (new Date(_vm.$store.getters.currentTerm.startDate) <= new Date()) ? _c('span', {
    staticClass: "week-days"
  }, [_vm._v(_vm._s(_vm.weekDays))]) : _c('span', {
    staticClass: "week-days"
  }, [_vm._v("Starts " + _vm._s(_vm._f("dayMonthYear")(_vm.$store.getters.currentTerm.startDate)))])]) : _vm._e(), _vm._v(" "), _c('carousel', {
    ref: "weeks",
    staticClass: "weeks col-sm-9",
    class: {
      '': _vm.isCoursePage, 'course-timeline': _vm.isCoursePage
    },
    attrs: {
      "easing": 'linear',
      "paginationEnabled": false,
      "perPage": 10
    }
  }, _vm._l((_vm.weeks), function(week, $index) {
    return _c('slide', {
      staticClass: "week"
    }, [(_vm.isVideoPlayer) ? _c('span', {
      class: {
        'past': ($index < _vm.currentWeek),
        'current': ($index === _vm.currentWeek && _vm.timeTravelWeek === null) || (_vm.isVideoPlayer && $index === _vm.timeTravelWeek),
        'future': ((_vm.timeTravelWeek && _vm.timeTravelWeek.toString()) && $index > _vm.currentWeek)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToWeek($index)
        }
      }
    }, [_vm._v("\n            Week " + _vm._s(week) + "\n            "), ($index === _vm.currentWeek) ? _c('i') : _vm._e(), _vm._v(" "), ((_vm.isVideoPlayer && $index === _vm.timeTravelWeek) || (_vm.timeTravelWeek === null && $index === _vm.currentWeek)) ? _c('i', {
      staticClass: "fa fa-circle"
    }) : _vm._e()]) : _c('span', {
      class: {
        'past': $index < _vm.currentWeek,
          'current': $index === _vm.currentWeek,
          'future': $index > _vm.currentWeek
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToWeek($index)
        }
      }
    }, [_vm._v("\n            Week " + _vm._s(week) + "\n            "), ($index === _vm.currentWeek) ? _c('i') : _vm._e(), _vm._v(" "), ((_vm.isVideoPlayer && $index === _vm.timeTravelWeek) || (_vm.timeTravelWeek === null && $index === _vm.currentWeek)) ? _c('i', {
      staticClass: "fa fa-circle"
    }) : _vm._e()])])
  }))], 1) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "current-week col-sm-3"
  }, [_c('span', {
    staticClass: "week-number"
  }, [_vm._v("Week 1")]), _vm._v(" "), _c('span', {
    staticClass: "week-days"
  }, [_vm._v("Starts " + _vm._s(_vm.localStorage.intake))])]), _vm._v(" "), _c('carousel', {
    ref: "weeks",
    staticClass: "weeks col-sm-9",
    class: {
      '': _vm.isCoursePage, 'course-timeline': _vm.isCoursePage
    },
    attrs: {
      "easing": 'linear',
      "paginationEnabled": false,
      "perPage": 10
    }
  }, _vm._l((16), function(week, index) {
    return _c('slide', {
      staticClass: "week"
    }, [_c('span', {
      class: {
        'past': index < _vm.currentWeek, 'current': index + 1 === _vm.currentWeek, 'future': index > _vm.currentWeek
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToWeek(index)
        }
      }
    }, [_vm._v("\n            Week " + _vm._s(week) + " \n\n            "), (index === _vm.currentWeek) ? _c('i', {
      staticClass: "fa fa-circle"
    }) : _vm._e()])])
  }))], 1), _vm._v(" "), (_vm.showGalleries) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('latest-galleries')], 1) : _vm._e(), _vm._v(" "), (!_vm.localStorage.roles.includes('Mentor') && _vm.terms && (_vm.$route.name === 'home' || _vm.$route.name === 'mentorDashboard') && _vm.localStorage.terms && _vm.localStorage.terms != 'null') ? _c('div', {
    staticClass: "term-selector col-xs-12"
  }, [(_vm.isInMentorship()) ? _c('ul', {
    staticClass: "term-tabs"
  }, [_vm._l((_vm.terms), function(term) {
    return (term.type !== 'mentorship' && !term.name.toLowerCase().includes('challenge')) ? _c('li', {
      class: [{
          'active': term.id == _vm.selectedTerm && _vm.$route.name === 'home'
        },
        {
          'no-click': _vm.localStorage.roles.includes('CampusStudent')
        },
        {
          'future': _vm.isInFuture(term.startDate)
        },
        term.type
      ],
      on: {
        "click": function($event) {
          _vm.changeTerm(term)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/home',
          query: {
            term: term.id
          }
        }
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(term.type)))])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.localStorage.terms.toString().split(',').length === 4) ? _c('li', {
    staticClass: "mentorship",
    class: {
      'active': _vm.$route.name === 'mentorDashboard'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/mentor-dashboard'
      }
    }
  }, [_vm._v("Mentorship")])], 1) : _vm._e()], 2) : _c('ul', {
    staticClass: "term-tabs"
  }, [_vm._l((_vm.terms), function(term) {
    return (term.type !== 'mentorship' && !term.name.toLowerCase().includes('challenge')) ? _c('li', {
      class: [{
          'active': term.id == _vm.selectedTerm
        },
        {
          'no-click': _vm.localStorage.roles.includes('CampusStudent')
        },
        {
          'future': _vm.isInFuture(term.startDate)
        },
        term.type
      ],
      on: {
        "click": function($event) {
          _vm.changeTerm(term)
        }
      }
    }, [_vm._v("\n                   " + _vm._s(_vm._f("capitalize")(term.type)) + "\n                ")]) : _vm._e()
  }), _vm._v(" "), (_vm.localStorage.terms.toString().split(',').length === 4) ? _c('li', {
    staticClass: "mentorship",
    class: {
      'active': _vm.$route.name === 'mentorDashboard'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/mentor-dashboard'
      }
    }
  }, [_vm._v("Mentorship")])], 1) : _vm._e()], 2), _vm._v(" "), _c('span', {
    staticClass: "divider"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b2e8b6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Timeline.vue
// module id = 1949
// module chunks = 2